<script setup lang="ts">
import {DateTime} from "luxon";

const {meta} = useAppConfig();
useHead({
  title: `${meta.title}-资讯中心`,
})

const route = useRoute()
const defaultPage = Number(route.query.page) || 1;
const defaultSize = Number(route.query.size) || 8;

const page = ref(defaultPage)
const size = ref(defaultSize)
const refreshNewsStore = ref(0)

const {data: newsStore} = await useAsyncData(
    `news`,
    () => uesApiFetchNewsList({
      page: page.value,
      size: size.value
    }, {
      key: `news-${refreshNewsStore.value}`,
    }).then(res => res.data.value),
    {
      watch: [page, size, refreshNewsStore],
    }
)

onMounted(() => {
  refreshNewsStore.value = refreshNewsStore.value + 1

  // element-ui 的分页组件
  const quickPrev = document.getElementsByClassName('.btn-quickprev')?.[0]
  const quickNext = document.getElementsByClassName('.btn-quicknext')?.[0]
  // 要移除所有的dom事件，则需要用到用克隆替换
  quickPrev?.replaceWith(quickPrev.cloneNode(true))
  quickNext?.replaceWith(quickNext.cloneNode(true))
})

watch([page, size], ([page, size]) => {
  navigateTo({
    path: `/news`,
    query: {
      page: page,
      size: size
    },
  }, {
    replace: true,
  })
})

function toInfo(id: number) {
  navigateTo({
    path: `/news/${id}`
  })
}

</script>

<template>
  <section class="pageNews">
    <div class="blockCenter">
      <div class="titleWrapper">
        <img src="/img/news/标题.png" alt="" class="imgTitle">
      </div>

      <section class="newsList">
        <div class="news" v-for="(item, index) in newsStore?.list" v-if="newsStore?.list" @click="toInfo(item.id)">
          <div class="imgWrapper">
            <img :src="item.img" alt="" class="img">
          </div>
          <div class="contentBlock">
            <div class="title">
              {{ item.name }}
            </div>
            <div class="content" v-html="html2str(item.text)"></div>
            <div class="timeFloor">
              {{ DateTime.fromSQL(item.time).toFormat('yyyy/MM/dd') }}
            </div>
          </div>
        </div>
      </section>

      <div class="paginationContainer">
      <div class="wrapper">
        <el-pagination
            class="pagination"
            background
            layout="prev, pager, next"
            :total="newsStore?.total"
            v-model:current-page="page"
            v-model:page-size="size"
        />
      </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.pageNews {
  background-color: $color-block-bg;

  .blockCenter {
    @include glx-center-block;
    padding-top: 33px;
    padding-bottom: 80px;

    display: flex;
    flex-direction: column;

    .titleWrapper {
      .imgTitle {
        object-fit: none;
      }
    }

    .newsList {
      margin-top: 26px;
      display: flex;
      flex-wrap: wrap;

      .news {
        width: 588px;
        height: 202px;
        background: #FFFFFF;
        border-radius: 4px;

        display: flex;


        &:nth-child(2n) {
          margin-left: 24px;
        }

        &:nth-child(n + 3) {
          margin-top: 20px;
        }

        &:hover {
          cursor: pointer;
          box-shadow: 0px 9px 13px 0px rgba(16, 16, 106, 0.16);
        }

        > .imgWrapper {
          align-self: center;
          position: relative;
          width: 186px;
          height: 162px;
          border-radius: 2px;
          margin-left: 20px;

          z-index: 0;

          &::before {
            content: '';
            display: block;
            position: absolute;

            width: 186px;
            height: 162px;
            border-radius: 2px;
            border: 1px solid #4C55AE;

            top: 7px;
            right: 7px;
            z-index: -1;
          }

          .img {
            width: 186px;
            height: 162px;
            border-radius: 2px;
            //object-fit: contain;
            object-fit: fill;
          }
        }

        > .contentBlock {
          margin-left: 17px;
          padding-top: 40px;
          padding-bottom: 40px;

          display: flex;
          flex-direction: column;

          .title {
            width: 351px;
            max-height: 44px;
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #26262C;
            line-height: 24px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box; //作为弹性伸缩盒子模型显示。
            -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
            -webkit-line-clamp: 2; //显示的行
          }

          > .content {
            width: 337px;
            max-height: 34px;
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #6E6E7B;
            line-height: 18px;
            margin-top: 14px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box; //作为弹性伸缩盒子模型显示。
            -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
            -webkit-line-clamp: 2; //显示的行
          }

          .timeFloor {
            margin-top: auto;

            font-family: PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #1628D1;
            line-height: 1;
          }
        }
      }
    }

    .paginationContainer {
      padding-top: 44px;
      margin-top: auto;

      >.wrapper{
        display: flex;
        &::before, &::after {
          content: '';
          display: block;
          height: 1px;
          background: rgba(#555881, 0.2);
          flex-grow: 1;
          align-self: center;
        }

        :deep(.el-pagination) {
          flex-shrink: 0;
          margin-left: 26px;
          margin-right: 26px;
          //:deep(.swiper-pagination-bullet) {
          //
          //}

          @mixin item() {
            width: 32px;
            height: 32px;
            line-height: 32px;
            border-radius: 2px;
          }

          .btn-prev, .btn-next {
            @include item();
            background: #555881;

            position: relative;

            .el-icon {
              display: none;
            }

            &::before {
              content: '';
              position: absolute;
              width: 11px;
              height: 11px;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }

          .btn-prev {
            &::before {
              @include glx-bg-img('/img/news/左翻页.png');
            }
          }

          .btn-next {
            &::before {
              @include glx-bg-img('/img/news/右翻页.png');
            }
          }

          .el-pager {
            .number {
              @include item();
              background: #FFFFFF;
              border: 1px solid #1628D1;

              font-family: PingFang SC;
              font-weight: 500;
              font-size: 16px;
              color: #1628D1;

              &.is-active {
                background: #1628D1;
                color: #FFFFFF;
              }
            }

            .btn-quicknext, .btn-quickprev {
              @include item();
              background: #FFFFFF;

              position: relative;

              svg {
                //display: none;
                color: blue;
              }

              //
              //&:before {
              //  content: '...';
              //  line-height: 1;
              //  position: absolute;
              //  color: #1628D1;
              //}
            }
          }
        }
      }
    }
  }
}
</style>